import { createUserModalStyles } from "@insite/content-library/Widgets/UserList/CreateUserModal";
import { css } from "styled-components";

Object.assign(createUserModalStyles, {
    ...createUserModalStyles,
    cancelButton: {
        css: css`
            background-color: #999;
            border: none;
            :hover {
                background-color: #999;
            }
        `,
    },
    submitButton: {
        css: css`
            margin-left: 1rem;
            :hover {
                background-color: #ab161a;
                border-color: #ab161a;
            }
        `,
    },
});
